import ModalView from '../../../../scripts/utils/modal-view.js';
import { fetcher } from '../../../../scripts/utils/fetch.js';
import Urls from '../urls.js';

export default class AddProductWithAccessoryModal extends ModalView {
	constructor({ el, modal_selector, accessory_data, product_data, navigation }) {
		super({ el, navigation, modal_selector });

		this.accessory_data = accessory_data;
		this.product_data = product_data;
		this.template_url = Urls.Templates.product_with_accessory_modal;
		this.render();
	}

	get_context() {
		return {
			navigation: this.navigation,
			accessory: this.accessory_data,
			product: this.product_data,
			total: this.get_total()
		};
	}

	get_total() {
		return parseFloat(this.accessory_data.Price) + parseFloat(this.product_data.Price);
	}

	after_render () {
		this.once_rendered();
		this.initSelectors();
	}

	initSelectors () {
		this.removeListeners();
		this.add_btn = document.querySelector('.js-accessory-bundle-to-cart');
		this.addListeners();
	}

	addListeners () {
		if (this.add_btn) {
			this.add_btn.addEventListener('click', this.addAccessory.bind(this));
		}
	}

	removeListeners () {
		if (this.add_btn) {
			this.add_btn.removeEventListener('click', this.addAccessory.bind(this));
		}
	}

	addAccessory(event) {
		const btn = event.currentTarget;
		var product_data = {
			ProductId: this.product_data.ProductId,
			ParentId: null,
			Qty: parseInt(this.accessory_data.Qty),
			DefaultOptions: btn.getAttribute('data-default-options') ? true : false,
			Children: [
				{
					ProductId: this.accessory_data.ProductId,
					Qty: parseInt(this.accessory_data.Qty)
				}
			]
		};

		btn.setAttribute('disabled', true);
		btn.classList.add('progress');

		fetcher(Urls.Api.product, {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(product_data)
		})
			.then(response => {
				const product_added_event = new CustomEvent('[add-to-cart]:product-added', { detail: response });

				document.dispatchEvent(product_added_event);
				this.goToCart();
			})
			.finally(() => {
				btn.removeAttribute('disabled');
				btn.classList.remove('progress');
			});
	}

	goToCart() {
		window.location.href = Urls.Api.cart;
	}
}